import React from "react";
import LegalLayout from "./LegalLayout";

const P = ({ children }) => <p>{children}</p>;

export default function Complaints() {
  return (
    <LegalLayout
      eyebrow="Client care"
      title="Complaints & Escalation"
      updated="February 2026"
      sections={[
        {
          id: "principles",
          title: "1. Our approach",
          body: (
            <P>
              A complaint is an opportunity. We take every concern seriously,
              small ones and large. We acknowledge complaints in writing
              within two business days and aim to substantively respond
              within 30 days. Where more time is needed, we tell you why and
              when to expect a full answer.
            </P>
          ),
        },
        {
          id: "step-1",
          title: "2. Step 1: Talk to us directly",
          body: (
            <P>
              The fastest path is to reach out to your advisor. Most concerns
              are resolved within a conversation. You can reach us at{" "}
              <a
                href="mailto:info@prosperafinancial.ca"
                className="text-[#8A6A2E] underline underline-offset-2"
              >
                info@prosperafinancial.ca
              </a>{" "}
              or +1 (416) 555-0102.
            </P>
          ),
        },
        {
          id: "step-2",
          title: "3. Step 2: Escalate to management",
          body: (
            <P>
              If you are not satisfied with your advisor's response, write to
              our Chief Compliance Officer with a description of the concern,
              the outcome you're seeking, and copies of any relevant
              documents. Response within 30 days.
            </P>
          ),
        },
        {
          id: "insurance",
          title: "4. Step 3 (insurance): Regulator & Ombudservice",
          body: (
            <P>
              For life &amp; living-benefits insurance complaints you may
              contact the <strong>OmbudService for Life &amp; Health
              Insurance (OLHI)</strong> at{" "}
              <a
                href="https://www.olhi.ca"
                className="text-[#8A6A2E] underline underline-offset-2"
              >
                olhi.ca
              </a>{" "}
              or the{" "}
              <strong>
                Financial Services Regulatory Authority of Ontario (FSRA)
              </strong>{" "}
              at{" "}
              <a
                href="https://www.fsrao.ca"
                className="text-[#8A6A2E] underline underline-offset-2"
              >
                fsrao.ca
              </a>
              .
            </P>
          ),
        },
        {
          id: "investments",
          title: "5. Step 3 (investments): CIRO & OBSI",
          body: (
            <P>
              For investment-related complaints you may contact the{" "}
              <strong>
                Canadian Investment Regulatory Organization (CIRO)
              </strong>{" "}
              or the{" "}
              <strong>
                Ombudsman for Banking Services and Investments (OBSI)
              </strong>{" "}
              at{" "}
              <a
                href="https://www.obsi.ca"
                className="text-[#8A6A2E] underline underline-offset-2"
              >
                obsi.ca
              </a>{" "}
              (free, independent, non-binding recommendations up to $350,000).
            </P>
          ),
        },
        {
          id: "records",
          title: "6. Our records",
          body: (
            <P>
              We maintain a complaints register in accordance with FSRA and
              CIRO expectations. Anonymized data is used to improve our
              processes and training.
            </P>
          ),
        },
      ]}
    />
  );
}
